import { LeadOrigin } from '../types'

/** Lee los parámetros UTM de la URL actual para atribuir el origen del lead. */
export function readOrigin(
  search: string,
  extra: Partial<LeadOrigin> = {},
): LeadOrigin {
  const params = new URLSearchParams(search)
  return {
    source: params.get('utm_source') || 'directo',
    medium: params.get('utm_medium') || 'organico',
    campaign: params.get('utm_campaign') || '',
    content: params.get('utm_content') || '',
    term: params.get('utm_term') || '',
    referrer: typeof document !== 'undefined' ? document.referrer : '',
    ...extra,
  }
}
